import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings.js";

import defaultCardImage from "../../images/shield-icon.svg";

import { ReactComponent as SvgDecoratorBlob3 } from "../../images/svg-decorator-blob-3.svg";

import SupportIconImage from "../../images/support-icon.svg";
import ShieldIconImage from "../../images/shield-icon.svg";
import CustomizeIconImage from "../../images/customize-icon.svg";
import FastIconImage from "../../images/fast-icon.svg";
import ReliableIconImage from "../../images/reliable-icon.svg";
import SimpleIconImage from "../../images/simple-icon.svg";

import DigitalMarketing from "../../images/portfolio/digital_marketing.png";
import WebAppDevelopment from "../../images/portfolio/web_and_apps.png";
import GraphicDesign from "../../images/portfolio/graphics_design.jpg";
import MediaManagement from "../../images/portfolio/media_management.png";
import EventNetworking from "../../images/portfolio/event_network.png";
import ProductionHouse from "../../images/portfolio/production_house.png";
const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;
const Heading = tw(SectionHeading)`w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;

const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-10 border-2 border-dashed border-primary-500 rounded-lg mt-12`}
  .imageContainer {
    ${tw`border-2 border-primary-500 text-center rounded-full p-2 flex-shrink-0 relative`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .textContainer {
    ${tw`mt-0 text-center`}
  }

  .title {
    ${tw`mt-2 font-bold text-xl leading-none text-primary-500`}
  }

  .description {
    ${tw`mt-3 font-semibold text-secondary-100 text-sm text-left leading-loose`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

export default () => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component):
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const cards = [

    {
      imageSrc: GraphicDesign, title: "Graphic Design & Printing",
      description: {
        1: "Logos & Brand Kits",
        2: "Business Cards, Flyers, Brochures",
        3: "Posters, Banners, Menu Cards",
        4: "Packaging Design",
        5: "Event Collaterals/ evites",
        6: "Custom Printing Solutions",
        7: " TV & LED Screen Banners",
        8: "PVC boards",
        9: "Hoardings & Outdoor Panels",
      }
    },
    {
      imageSrc: WebAppDevelopment,
      title: "Web & App Development",
      description: {
        1: "Websites (Corporate / E- Commerce)",
        2: "Mobile Apps",
        3: "UI/UX Design",
        4: "SEO Integration",
        5: "AI Chat Bots",
        6: "AI Apps",
        7: "AI Content",
      }
    },
    {
      imageSrc: DigitalMarketing,
      title: "Digital & Influential Marketing",
      description: {
        1: "Social Media Marketing",
        2: "Paid Ads (Google, Meta)",
        3: "Influencer Collaborations",
        4: "Content Strategy",
        5: "EDDM (Every Door Direct Mail)",
        6: "Brand Strategy and Creative Campaigns",
      }
    },
    {
      imageSrc: MediaManagement,
      title: "Media Management",
      description: {
        1: "Event Media Coverage",
        2: "Photography & Videography",
        3: "LED Panel Rents",
        4: "Video Ads",
        5: "Story & Songs Production",
      }
    },
    {
      imageSrc: EventNetworking,
      title: "Event Networking",
      description: {
        1: "Asian Sports Tournaments (FPL & ASF)",
        2: "Corporate Leagues",
        3: "Business & Cultural Meets",
        4: "Sponsorship Drives",
        5: "Community Team Building Activities",
      }
    },
    {
      imageSrc: ProductionHouse,
      title: "Production House",
      description: {
        1: "End-to-end creative direction",
        2: "Strategic media planning time",
        3: "Promotions & Campaign Rollout",
        4: "Digital buzz creation",
        5: "Audience-focused storytelling",
        6: "Results-driven execution",
      },
    },
  ];

  return (
    <Container>
      <ThreeColumnContainer>
        <Heading>Our Key <span tw="text-primary-500">Services</span></Heading>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title || "Fully Secure"}</span>
                <ul className="description">
                  {card.description && typeof card.description === 'object' ? (
                    Object.values(card.description).map((desc, index) => (
                      <li key={index}>• {desc}</li>
                    ))
                  ) : (
                    <li>{card.description || "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."}</li>
                  )}
                </ul>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
